import AdvancedAudit from './Master/AdvancedAudit.vue';
import AdvancedAuditCreateEdit from 'src/views/Pages/Dashboard/AdvancedAudit/Master/AdvancedAuditCreateEdit.vue';
import IndexAdvancedAudit from './IndexAdvancedAudit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import ReportAdvancedAudit from './Report/Reports.vue';
import SamplingReport from './SamplingReport/SamplingReport.vue';
import AdvancedAuditCapture from './AdvancedAudit/Capture.vue';
import AdvancedAuditCompliance from './ComplianceReport/ComplianceReports.vue';

const AdvancedAuditRoutes = {
  path: 'advanced',
  name: 'audit.audit',
  component: IndexAdvancedAudit,
  children: [
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'inspections',
          name: 'audit.audit',
          component: ReportAdvancedAudit,
          meta: {
            prefix_permission: 'advanced_audits_inspections',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'samplingreport',
          name: 'audit.audit',
          component: SamplingReport,
          meta: {
            prefix_permission: 'advanced_audits_samplingreport',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'admin',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'audit.audit',
              component: AdvancedAudit,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
            {
              path: 'create',
              name: 'audit.audit',
              component: AdvancedAuditCreateEdit,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
            {
              path: 'edit',
              name: 'audit.audit',
              component: AdvancedAuditCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'captures',
          name: 'audit.audit',
          component: AdvancedAuditCapture,
          meta: {
            prefix_permission: 'advanced_audits_captures',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'compliance',
          name: 'audit.complience_report',
          component: AdvancedAuditCompliance,
          meta: {
            prefix_permission: 'advanced_audits_compliance',
          },
        },
      ],
    },
  ],
};

export default AdvancedAuditRoutes;
